<script setup lang="ts">
import {RefreshCcw04, SearchMd, Moon01} from "utruckin-icons";
import {useRoute} from "vue-router";
import {computed, onMounted, onUnmounted, ref} from "vue";
import WidgetProfile from "@/components/widget/WidgetProfile.vue";
import {useAppStore} from "@/store/app.store";
import {useTheme} from "@/utils/useMode";
import CommonModal from "@/components/common/CommonModal.vue";
import GlobalSearchInput from "@/components/widget/ui/globalSearchInput.vue";
import GlobalSearchTab from "@/components/widget/ui/globalSearchTab.vue";

const route = useRoute();
const appStore = useAppStore();
const {toggleTheme, watchSystemTheme} = useTheme();

let cleanup: (() => void) | null = null;

const searchModal = ref<boolean>(false);
const loading = ref<boolean>(true);

const routerName = computed(() => {
  const fullRoute = route.name as string;
  return fullRoute?.split("-")[0];
});

const refresh = () => {
  appStore.triggerRefresh();
};

const openSearchModal = () => {
  searchModal.value = true;
}

const closeModal = () => {

}

onMounted(() => {
  cleanup = watchSystemTheme();
});

onUnmounted(() => {
  cleanup?.();
});
</script>

<template>
  <div class="c-w-header">
    <div class="title" :class="route.params.id ? 'link' : ''">
      <div class="title__name">{{ routerName }}</div>
      <span class="title__sub" v-if="route.params.id"
      >/ {{ route.params.id }}</span
      >
    </div>

    <div class="actions">
      <div class="search" @click="openSearchModal">
        <SearchMd :search="20"/>

        <span>Search</span>
      </div>

      <div class="refresh" @click="refresh">
        <RefreshCcw04 :size="24"/>
      </div>

      <div class="theme" @click="toggleTheme">
        <Moon01 :size="24"/>
      </div>

      <WidgetProfile/>
    </div>
  </div>

  <CommonModal
      v-model="searchModal"
      @close="closeModal"
      :close-on-overlay="true"
  >
    <div>
      <GlobalSearchInput />

      <GlobalSearchTab />
    </div>
  </CommonModal>
</template>

<style lang="scss">
.c-w-header {
  padding: 16px;
  height: 72px;
  width: 100%;
  border-bottom: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title {
    display: flex;
    align-items: end;
    gap: 4px;
    color: var(--color-label);

    &.link {
      .title__name:hover {
        text-decoration: underline;
      }
    }

    &__name {
      cursor: pointer;
      text-transform: capitalize;
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
    }

    &__sub {
      font-size: 14px;
      line-height: 22px;
      color: var(--color-secondary-label);
    }
  }

  .actions {
    display: flex;
    gap: 8px;

    .refresh,
    .theme {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid var(--color-border);
      border-radius: 12px;
      cursor: pointer;
      color: var(--color-label);

      path {
        stroke-width: 1.5px !important;
      }

      &:hover {
        background: var(--color-bg-secondary);
      }
    }

    .search {
      width: 240px;
      height: 40px;
      border: 1px solid var(--color-border);
      background: var(--color-bg-secondary);
      border-radius: 12px;
      cursor: pointer;
      padding: 10px 12px;
      display: flex;
      align-items: center;
      gap: 8px;
      color: var(--color-secondary-label);

      &:hover {
        border: 1.5px solid var(--color-secondary-label);
      }

      span {
        background: transparent;
      }
    }
  }
}
</style>
